export default __webpack_public_path__ + "static/media/website-info.473860e3.png";